import React from "react";
import clsx from "clsx";
import {
  getThemeClass,
  getThemeComponentClasses,
} from "@/src_new/shared/lib/themeComponentClasses";

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "solid" | "outline";
  size?: "sm" | "md" | "lg";
};

export default function Button({ variant = "solid", size = "md", className, ...props }: Props) {
  const buttonClasses = getThemeComponentClasses().button;

  return (
    <button
      className={clsx(
        /* Base */
        "inline-flex items-center justify-center font-semibold transition-all focus:outline-none disabled:opacity-50 disabled:pointer-events-none",

        /* Shape (matches UI) */
        "rounded",

        /* Variants */
        variant === "solid" &&
          clsx(
            getThemeClass(buttonClasses.solidBgColor, "bg-theme-primary"),
            getThemeClass(buttonClasses.solidTextColor, "text-theme-text-inverse"),
            "hover:bg-theme-primary-hover",
            buttonClasses.solid
          ),
        variant === "outline" &&
          clsx(
            "border-2 hover:bg-theme-surface-muted",
            getThemeClass(buttonClasses.outlineBorderColor, "border-theme-border-strong"),
            getThemeClass(buttonClasses.outlineTextColor, "text-theme-text"),
            buttonClasses.outline
          ),

        /* Sizes */
        size === "sm" && "px-4 py-1 text-sm",
        size === "md" && "px-6 py-3 text-base",
        size === "lg" && "px-8 py-4 text-lg",

        buttonClasses.base,
        className
      )}
      {...props}
    />
  );
}
